const resetPassword = async (email: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL + '/api/v1/users/reset-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email
        })
      });

      if (response.ok) {
        const json = await response.json();
        resolve(json);
      } else {
        const json = await response.json();
        reject(json);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export default resetPassword;
